module.exports = __webpack_public_path__ + "img/abc.1dc1d2b2.png";